
// if you have CSS for sale strip
import "./styles/responsive.css";
import AppRoutes from "./routes/AppRoutes";
import Footer from "./comopnents/Footer";
import TopBar from "./comopnents/TopBar";
import Header from "./comopnents/Header";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import ScrollToTop from "./comopnents/ScrollToTop";
import { ThemeProvider } from "./comopnents/theme";
// import ChatbotWidget from "./comopnents/chatbot";

function App() {
  const location = useLocation();
  const hideLayout = [
    "/winner-list",
    "/luckydraw",
  ].includes(location.pathname);

  // Check if the current route is admin
  const isAdminRoute = location.pathname.startsWith("/admin") || location.pathname.startsWith("/Invoice");
  const [isModalOpen, setIsModalOpen] = useState(false)

  const publicLayout = (
    <div className="storefront-shell">
       <TopBar />

      {!hideLayout && (
        <Header
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      )}
      <div>
        {/* <div className="sale-strip small-sale">
          <span>BIG SALE</span>
          <strong>50% OFF</strong>
          <small>Limited Time Offer</small>
        </div> */}
      </div>
      <ScrollToTop />
      <AppRoutes />
      {/* <ChatbotWidget /> */}
      <Footer />
    </div>
  );

  return (
    <> <ThemeProvider >
      {isAdminRoute ? (
        <>
          <ScrollToTop />
          <AppRoutes />
        </>
      ) : (
        publicLayout
      )}
      </ThemeProvider>
    </>
  );
}

export default App;



// import React, { useState } from "react";
// import QRCode from "qrcode";
// import html2pdf from "html2pdf.js";
// import logo from "./assets/logo.png";

// const App = () => {
//   const [from, setFrom] = useState("");
//   const [to, setTo] = useState("");

//   const generatePDF = async () => {
//     const start = Number(from);
//     const end = Number(to);

//     if (!start || !end || start > end) {
//       alert("Enter valid range");
//       return;
//     }

//     const values = [];
//     for (let i = start; i <= end; i++) values.push(i);

//     const qrBase64List = await Promise.all(
//       values.map(v => QRCode.toDataURL(`P26${v}`))
//     );

//     const html = `
//     <html>
//     <style>
// @font-face {
//   font-family: "Poppins";
//   src: url("/fonts/Poppins-Medium.ttf") format("truetype");
//   font-weight: 500;
// }@font-face {
//   font-family: "BebasNeue";
//   src: url("/fonts/BebasNeue-Regular") format("truetype");
//   font-weight: 500;
// }
//   .label-box {
//     page-break-inside: avoid;
//     break-inside: avoid;
//   }
//   </style>
//       <body style="padding:20px; font-family:Arial;">
//         ${values.map((value, index) => `
//           <div class="label-box" style="
//             margin-bottom:20px;
//             padding:1px;
//             border:1px solid #ccc;
//             border-radius:12px;
//             background:#fff;
//             display:flex;
//             justify-content:space-between;
//             align-items:center;
//           ">
//             <div style="flex:1; text-align:center;">
//             <img
//               src=${logo}
//               alt="Pixel India Logo"
//               style="height:50px;width:300px; margin-bottom:10px;"
//             />
//               <div style="font-size:16px; font-weight:bold;font-family:BebasNeue">
//                 PIXELED INDIA PRIVATE LIMITED
//               </div>

//               <div style="font-size:24px;font-family:Poppins;">Hyderabad</div>

//               <div style="font-size:50px; font-weight:bold;font-family:Poppins;">
//                 Rack : P26${value}
//               </div>
//             </div>   

//             <div style=" display:flex; justify-content:center;">
//               <img src="${qrBase64List[index]}" width="280" height="280" />
//             </div>
//           </div>
//         `).join("")}
//       </body>
//     </html>
//     `;

//     const container = document.createElement("div");
//     container.innerHTML = html;

//     html2pdf()
//       .from(container)
//       .set({
//         margin: 0.5,
//         filename: `Rack_QR_${from}_to_${to}.pdf`,
//       html2canvas: { scale: 2, useCORS: true },
//         jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
//       })
//       .save();
//   };

//   return (<>
//     <div style={{ padding: 20,display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',height:'100vh',gap:20 }}>
//       <h3>Generate Rack QR PDF</h3>

//       <input
//         placeholder="From"
//         value={from}
//         onChange={(e) => setFrom(e.target.value)}
//         style={{ marginRight: 10 }}
//       />

//       <input
//         placeholder="To"
//         value={to}
//         onChange={(e) => setTo(e.target.value)}
//         style={{ marginRight: 10 }}
//       />

//       <button onClick={generatePDF}>Generate PDF</button>
//     </div>
//     </>
//   );
// };

// export default App;





// import React from "react";
// import QRCode from "qrcode";
// import html2pdf from "html2pdf.js";
// import logo from "./assets/logo.png";

// const App = () => {

//   const racks =[

// ]



//   const generatePDF = async () => {

//     const logoBase64 = await fetch(logo)
//       .then(res => res.blob())
//       .then(blob =>
//         new Promise(resolve => {
//           const reader = new FileReader();
//           reader.onloadend = () => resolve(reader.result);
//           reader.readAsDataURL(blob);
//         })
//       );

//     // QR codes containing rack number
//     const qrList = await Promise.all(
//       racks.map(code => QRCode.toDataURL(`Rack:${code}`, { width: 400 }))
//     );

//     const container = document.createElement("div");
//     container.style.background = "white";
//     container.style.padding = "20px";

//     container.innerHTML = `
//       ${racks.map((code, index) => `
//         <div style="
//           width:100%;
//           margin-bottom:25px;
//           border:1px solid #dcdcdc;
//           border-radius:18px;
//           padding:20px;
//           background:#f4f4f4;
//           box-sizing:border-box;
//           ${(index + 1) % 3 === 0 ? "page-break-after: always;" : ""}
//         ">
//           <table style="width:100%; border-collapse:collapse;">
//             <tr>
//               <td style="width:65%; text-align:center;">
                
//                 <img src="${logoBase64}" style="height:60px; margin-bottom:8px;" />

//                 <div style="font-size:14px; font-weight:bold;">
//                   PIXELED INDIA PRIVATE LIMITED
//                 </div>

//                 <div style="font-size:20px; margin:8px 0;">
//                   Hyderabad
//                 </div>

//                 <div style="font-size:35px; font-weight:700;">
//                   Rack No :<span style="font-size:50px; fontweight:800"> ${code}</span>
//                 </div>

//               </td>

//               <td style="width:35%; padding-left:10px;">
//                 <img src="${qrList[index]}" style="width:210px; height:210px;" />
//               </td>
//             </tr>
//           </table>
//         </div>
//       `).join("")}
//     `;

//     document.body.appendChild(container);

//     await new Promise(resolve => setTimeout(resolve, 300));

//     await html2pdf()
//       .from(container)
//       .set({
//         margin: 0.4,
//         filename: "Rack_QR_Labels.pdf",
//         html2canvas: {
//           scale: 2,
//           useCORS: true
//         },
//         jsPDF: {
//           unit: "mm",
//           format: "a4",
//           orientation: "portrait"
//         }
//       })
//       .save();

//     document.body.removeChild(container);
//   };

//   return (
//     <div
//       style={{
//         height: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         flexDirection: "column"
//       }}
//     >
//       <h3>Generate Rack QR PDF</h3>
//       <button
//         onClick={generatePDF}
//         style={{
//           padding: "10px 20px",
//           fontSize: "16px",
//           cursor: "pointer"
//         }}
//       >
//         Generate PDF
//       </button>
//     </div>
//   );
// };

// export default App;
